import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreateSmsCampaigns,
  useUpdateSmsCampaigns,
} from "../../../../hooks/api/mutations/useMarketing";
import { pathConstants } from "../../../../routes/pathContants";
import { cleanObject } from "../../../../helpers";

export const useSmsCampaignContextForm = ({
  smsCampaign = {},
  isEditMode = false,
}) => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    title: smsCampaign?.title || "",
    description: smsCampaign?.description || "",
  });
  const navigate = useNavigate();

  const { mutate: createSmsCampaign, isLoading: isCreatingCampaign } =
    useCreateSmsCampaigns();
  const { mutate: updateSmsCampaign, isLoading: isUpdatingCampaign } =
    useUpdateSmsCampaigns(id);

  const handleCreateSmsCampaign = () => {
    createSmsCampaign(cleanObject({ ...formData }), {
      onSuccess: (res) => {
        navigate(
          pathConstants.MARKETING_SMS_CAMPAIGNS_AUDIENCE({
            id: res?.data?.data?.id,
          }),
        );
      },
    });
  };

  const handleUpdateSmsCampaign = () => {
    updateSmsCampaign(
      { id, data: cleanObject({ ...formData }) },
      {
        onSuccess: () => {
          navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_AUDIENCE({ id }));
        },
      },
    );
  };

  const handleSubmitCampaign = () => {
    if (isEditMode) return handleUpdateSmsCampaign();

    handleCreateSmsCampaign();
  };
  return {
    isLoading: isCreatingCampaign || isUpdatingCampaign,
    formData,
    setFormData,
    handleSubmitCampaign,
  };
};
